import * as React from "react"
import Svg, { G, Path, Defs, ClipPath } from "react-native-svg"

function SvgComponent(props) {
  return (
    <Svg
      width={12}
      height={12}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <G fill="#616161" clipPath="url(#clip0_12424_9152)">
        <Path d="M6 6.375a2.25 2.25 0 110-4.5 2.25 2.25 0 010 4.5zm0-3.75a1.5 1.5 0 100 3 1.5 1.5 0 000-3z" />
        <Path d="M6 11.625a5.624 5.624 0 01-4.346-2.059l-.195-.24.195-.236a5.625 5.625 0 018.692 0l.195.236-.195.24A5.625 5.625 0 016 11.625zM2.441 9.33a4.876 4.876 0 007.125 0 4.875 4.875 0 00-7.125 0z" />
        <Path d="M6 11.625A5.624 5.624 0 115.992.376 5.624 5.624 0 016 11.625zm0-10.5a4.875 4.875 0 100 9.75 4.875 4.875 0 000-9.75z" />
        <Path d="M1.943 9.33s3.776 4.219 7.62.42l.495-.42S6.848 6 3.588 8L1.944 9.33zM6 6a1.875 1.875 0 100-3.75A1.875 1.875 0 006 6z" />
      </G>
      <Defs>
        <ClipPath id="clip0_12424_9152">
          <Path fill="#fff" d="M0 0H12V12H0z" />
        </ClipPath>
      </Defs>
    </Svg>
  )
}

export default SvgComponent
